import Comp from "./CommentFeed";
export default Comp;
